import { useEffect, useMemo, useState } from "react";
import type { OperationLogEntry } from "../core/types";
import { operationLogger } from "../core/operations/OperationLogger";

export function OperationLog() {
  const [entries, setEntries] = useState<OperationLogEntry[]>(operationLogger.snapshot);
  const [deviceFilter, setDeviceFilter] = useState("");
  const [jobFilter, setJobFilter] = useState("");
  useEffect(() => operationLogger.subscribe(setEntries), []);

  const devices = useMemo(() => Array.from(new Set(entries.map((entry) => entry.deviceLabel).filter(Boolean) as string[])).sort(), [entries]);
  const jobs = useMemo(() => Array.from(new Set(entries.map((entry) => entry.jobId).filter(Boolean) as string[])), [entries]);
  const filtered = entries.filter((entry) => (
    (!deviceFilter || entry.deviceLabel === deviceFilter) && (!jobFilter || entry.jobId === jobFilter)
  ));

  const download = (content: string, name: string, type: string) => {
    const url = URL.createObjectURL(new Blob([content], { type }));
    const anchor = document.createElement("a");
    anchor.href = url;
    anchor.download = name;
    anchor.click();
    URL.revokeObjectURL(url);
  };

  return (
    <section className="panel log-panel">
      <div className="panel-heading">
        <p className="eyebrow">CHẨN ĐOÁN</p>
        <div className="button-row compact">
          <button className="secondary" onClick={() => download(operationLogger.exportText(), "usb-workbench.log.txt", "text/plain")}>TXT</button>
          <button className="secondary" onClick={() => download(operationLogger.exportJson(), "usb-workbench.log.json", "application/json")}>JSON</button>
          <button className="ghost" onClick={() => operationLogger.clear()}>Xóa</button>
        </div>
      </div>
      {(devices.length > 0 || jobs.length > 0) && (
        <div className="log-filters">
          <label>Thiết bị <select value={deviceFilter} onChange={(event) => setDeviceFilter(event.target.value)}><option value="">Tất cả</option>{devices.map((device) => <option key={device}>{device}</option>)}</select></label>
          <label>Job <select value={jobFilter} onChange={(event) => setJobFilter(event.target.value)}><option value="">Tất cả</option>{jobs.map((job) => <option value={job} key={job}>{job.slice(0, 8)}</option>)}</select></label>
        </div>
      )}
      <div className="log-list">
        {filtered.length === 0 ? <p className="muted">Chưa có hoạt động phù hợp bộ lọc.</p> : filtered.slice(-100).reverse().map((entry, index) => (
          <div className={`log-entry ${entry.status}`} key={`${entry.timestamp}-${index}`}>
            <time>{new Date(entry.timestamp).toLocaleTimeString("vi-VN")}</time>
            <b>{entry.protocol} · {entry.operation}{entry.deviceLabel ? ` · ${entry.deviceLabel}` : ""}</b>
            <span>{entry.message}{entry.connectionEpoch !== undefined ? ` · epoch ${entry.connectionEpoch}` : ""}</span>
            {entry.errorCode ? <code>{entry.errorCode}</code> : entry.jobId ? <small title={entry.jobId}>job {entry.jobId.slice(0, 8)}</small> : null}
          </div>
        ))}
      </div>
    </section>
  );
}
